module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_DownArrow_16"],"polygon":[{"$":{"points":"10 8 10 2 6 2 6 8 3 8 8 14 13 8 10 8","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_DownArrow_16.svg
// module id = v4Vt
// module chunks = 1